import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../../shared/css/Loader.css';
import '../../shared/css/generic-styles.css';
var Loader = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'icon' : _b;
    var dotInnerStyle = {
        backgroundColor: "rgb(var(".concat(color, "))")
    };
    return (_jsxs("div", { className: "loader", children: [_jsx("div", { className: 'dot', children: _jsx("div", { className: 'dot-inner', style: dotInnerStyle }) }), _jsx("div", { className: 'dot', children: _jsx("div", { className: 'dot-inner', style: dotInnerStyle }) }), _jsx("div", { className: 'dot', children: _jsx("div", { className: 'dot-inner', style: dotInnerStyle }) }), _jsx("div", { className: 'dot', children: _jsx("div", { className: 'dot-inner', style: dotInnerStyle }) }), _jsx("div", { className: 'dot', children: _jsx("div", { className: 'dot-inner', style: dotInnerStyle }) })] }));
};
export { Loader }; // If you'd like to use named exports, replace this with: export const Loader = ...
